"use client";

import { useEffect } from "react";
import { useStore } from "@/hooks/use-store";
import { configApi } from "@/domains/config/service";

export function useLoadConfig() {
  const { config } = useStore();

  useEffect(() => {
    if (config.getCountry()) return;

    const load = async () => {
      try {
        const res = await configApi.fetchConfig();
        const data = res.data;

        config.setCountry(data.country.toLowerCase());
        config.setCashbackList(data.cashbackList);
      } catch {
        return;
      }
    };

    load();
  }, [config]);
}
